<template>
    <div class="banner-section">
      <img :src="bannerImage" alt="Promotional Banner" class="banner-image" />
    </div>
  </template>
  
  <script>
  export default {
    name: "SAchatCommingSoonBanner",
    data() {
      return {
        bannerImage: require('@/assets/images/ReplaceNRIBannerinExpertView (2).png'),
      };
    },
  };
  </script>
  
  <style lang="scss" scoped>
  .banner-section {
    margin: 0px;
    text-align: center;
  
    .banner-image {
      width: 100%;
      margin: 10px 0px 20px 0px;
      border-radius: 8px;
      object-fit: cover;
    }
  }
  
  /* Responsive Styles */
  @media screen and (max-width: 1060px) {  // Tablets
    .banner-section {
  
    .banner-image {
      margin: 10px 0px 110px 0px;
    }
  }
  }
  </style>